import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
  component: HomeRedirect,
});

function HomeRedirect() {
  const router = useRouter();
  useEffect(() => {
    const token = localStorage.getItem("token");
    void router.navigate({ to: token ? "/dashboard" : "/login", replace: true });
  }, [router]);
  return null;
}
